/**
 * Represents the type of a [[TicketType]] entity.
 */
export var TicketTypeType;
(function (TicketTypeType) {
    /**
     * A normal ticket type that contains a single ticket.
     */
    TicketTypeType["Normal"] = "Normal";
    /**
     * A package ticket type that contains one or more tickets and zero or more items.
     */
    TicketTypeType["Package"] = "Package";
})(TicketTypeType || (TicketTypeType = {}));
//# sourceMappingURL=ticket-type-type.js.map